module.exports = require("@swa-ui/authentication/src/components/MfaProtected/MfaProtected.module.scss");